import api from './api';
import courseGroupsMock from '@/mocks/courseGroups';

/**
 * Grupos escolares usam o mesmo recurso do backend: /corporate/course-groups
 * (course.type=2 + course_group). Mock só com VUE_APP_COURSE_GROUPS_MOCK=true.
 */
function useMock() {
    return String(process.env.VUE_APP_COURSE_GROUPS_MOCK || '').toLowerCase() === 'true'
        || process.env.VUE_APP_COURSE_GROUPS_MOCK === '1';
}

function authHeaders(accessToken) {
    return {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
    };
}

/** Garante courseIds a partir de items quando o backend só envia items. */
function normalizeGroup(row) {
    if (!row || typeof row !== 'object') return row;
    const fromItems = Array.isArray(row.items)
        ? row.items
            .map((item) => (item?.courseId != null ? String(item.courseId) : null))
            .filter(Boolean)
        : [];
    const courseIds = Array.isArray(row.courseIds) && row.courseIds.length
        ? row.courseIds.map(String)
        : fromItems;
    const name = row.name || row.comercialName || row.commercialName || '';
    return {
        ...row,
        name,
        comercialName: row.comercialName || row.commercialName || name,
        commercialName: row.commercialName || row.comercialName || name,
        courseIds,
        mode: row.mode === 'path' ? 'path' : (row.mode || 'group'),
    };
}

export default {
    async list(accessToken, params = {}) {
        if (useMock()) return courseGroupsMock.list(params);
        const response = await api.get('/corporate/course-groups', {
            headers: authHeaders(accessToken),
            params: {
                search: params.search || undefined,
                status: params.status || undefined,
                mode: params.mode || undefined,
            },
        });
        const data = response.data || {};
        const content = Array.isArray(data.content)
            ? data.content.map(normalizeGroup)
            : [];
        return {
            ...data,
            content,
            totalElements: Number(data.totalElements ?? content.length) || 0,
        };
    },

    async getById(id, accessToken) {
        if (useMock()) return courseGroupsMock.getById(id);
        const response = await api.get(`/corporate/course-groups/${id}`, {
            headers: authHeaders(accessToken),
        });
        return normalizeGroup(response.data);
    },

    async create(payload, accessToken) {
        if (useMock()) return courseGroupsMock.create(payload);
        const response = await api.post('/corporate/course-groups', payload, {
            headers: authHeaders(accessToken),
        });
        return normalizeGroup(response.data);
    },

    async update(id, payload, accessToken) {
        if (useMock()) return courseGroupsMock.update(id, payload);
        const response = await api.put(`/corporate/course-groups/${id}`, payload, {
            headers: authHeaders(accessToken),
        });
        return normalizeGroup(response.data);
    },

    async remove(id, accessToken) {
        if (useMock()) return courseGroupsMock.remove(id);
        const response = await api.delete(`/corporate/course-groups/${id}`, {
            headers: authHeaders(accessToken),
        });
        return response.data;
    },
};
